<template>
  <div>
    <CustomTable
      title="Настройка параметров типа конструкции"
      :rowsData="this.rowsData"
      :columns="this.frameTypesColumns"
      :loading="isFetching"
      :small="true"
      :show-search="true"
      :custom-body="true"
      :sticky-header="true"
      :update-data="this.getData"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center">
            {{ props.row.frame_type_id }}
          </custom-table-cell>
          <custom-table-cell align="left">
            {{ props.row.frame_type_name }}
          </custom-table-cell>
          <custom-table-cell align="center" class="actions">
            <q-btn
              @click="() => this.handleUpdateClick(props.row.frame_type_id)"
              color="primary"
              v-close-popup
              size="sm"
              class="action-btn"
            >
              Параметры
              <q-icon name="edit" />
            </q-btn>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { MODAL_NAMES } from "@/constants";
import {
  frameTypesColumns,
  getAllFrameTypes,
} from "@/views/Frames/Types/services";
import { useAppStore } from "@/services/store/app";

export default {
  name: "FrameTypes",
  components: { CustomTableCell, CustomTable },
  data() {
    return {
      frameTypesColumns,
      rowsData: [],
      isFetching: false,
      deleteLoading: {},
      loading: false,
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getAllFrameTypes()
      this.isFetching = false
      if (!res) return
      this.rowsData = res
    },
    async handleUpdateClick(frame_type_id) {
      this.showModal(MODAL_NAMES.FRAME_TYPE_PARAMS, {
        title: 'Параметры',
        frame_type_id: frame_type_id
      })
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showModal } = useAppStore()
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showModal };
  },
}
</script>

<style scoped lang="scss">
.actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn {
  padding: 7px 16px;
  border-radius: 8px;

  :deep(.q-btn__content) {
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
</style>
